/**
 * Credit Union Product Compare - Dynamic Load
 * Responsible for determining if the PC table is present, and for actually loading the files.
 * @author Oliver Boermans
 */

//
// Dependencies
import * as registry from '../../registry';
import { CU_PRODUCT_COMPARE_MODULE } from '../../registry/names';

//
// Constants
export const MODULE_NAME = CU_PRODUCT_COMPARE_MODULE;
export const MODULE_SELECTOR = '[data-cu-pc]';
export const ASSETS = [
	'../styles/cu-product-compare.module.css',
	'../scripts/cu-product-compare.module.js',
];

//
// Load
export default function load() {
	registry.dynamicLoader(MODULE_NAME, MODULE_SELECTOR, ASSETS);
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/cu-product-compare/dynamic-load.js